import React, { useState } from 'react';
import type { ToolComponent } from '../types';
import { getToolDisplayName, shouldHideTool } from '../utils';

interface ToolBlockProps {
  id: string;
  toolName: string;
  toolInput: any;
  toolOutput: any;
  toolIsError?: boolean;
  isStreaming?: boolean;
  toolRegistry?: Map<string, ToolComponent>;
  className?: string;
}

export const ToolBlock: React.FC<ToolBlockProps> = ({
  id,
  toolName,
  toolInput,
  toolOutput,
  toolIsError,
  isStreaming,
  toolRegistry,
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Check if this tool should be hidden
  if (shouldHideTool(toolName, toolInput)) {
    return null;
  }

  // Get the tool component from registry or use default
  let ToolComponent: ToolComponent;

  if (toolRegistry && toolRegistry.has(toolName)) {
    ToolComponent = toolRegistry.get(toolName)!;
  } else {
    // Import default tool components from AppEditor
    const { getToolComponent } = require('../../AppEditor/tools');
    ToolComponent = getToolComponent(toolName);
  }

  const description = getToolDisplayName(toolName, toolInput);

  return (
    <div data-msg-id={id} className={className}>
      <ToolComponent
        toolName={toolName}
        input={toolInput}
        output={toolOutput}
        isError={toolIsError}
        isExpanded={isExpanded}
        onToggle={() => setIsExpanded(!isExpanded)}
        isStreaming={isStreaming}
      />
    </div>
  );
};
